import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class EmisorUpsertFiscalAddressForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.getRules({}))
    };
  }

  getRules(data) {
    const isFiscalAddressTouched = this.isFiscalAddressTouched(data);

    return {
      'cp': ['required', 'min:5', 'max:5', 'regex:/^[0-9]{5}$/'],
      'direccion': [isFiscalAddressTouched ? 'required' : 'string', 'min:5', 'max:150'],
      'estado': [isFiscalAddressTouched ? 'required' : 'string', 'min:2', 'max:50'],
      'ciudad': [isFiscalAddressTouched ? 'required' : 'string', 'min:2', 'max:50'],
    }
  }

  componentDidMount() {
    this.handleOnChange({});
  }

  isFiscalAddressTouched = (values) => {
    const props = ['direccion', 'estado', 'ciudad'];
    let touched = false;

    for (const prop of props) {
      if (values[prop] !== undefined && values[prop] !== '') {
        touched = true;
        break;
      }
    }

    return touched;
  }

  validate(data) {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  handleFiscalAddressCheckboxOnChange = (event) => {
    const { name, checked} = event.target;

    this.notifyFormDataChange({
      [name]: checked,
      direccion: undefined,
      ciudad: undefined,
      estado: undefined,
    })
  }

  notifyFormDataChange = (values) => {
    const data = {
      ...this.props.data,
      ...values
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: 'fiscal_address',
      isValid:  validator.passes()
    });
  }

  render() {
    const { data, autoFocus } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Código postal"
          name="cp"
          placeholder=""
          help=""
          autoFocus={ autoFocus }
          validator={ validator }
          value={ data.cp }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Dirección"
          name="direccion"
          placeholder="Opcional"
          help=""
          validator={ validator }
          value={ data.direccion }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Ciudad"
          name="ciudad"
          placeholder="Opcional"
          help=""
          validator={ validator }
          value={ data.ciudad }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Estado"
          name="estado"
          placeholder="Opcional"
          help=""
          validator={ validator }
          value={ data.estado }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default EmisorUpsertFiscalAddressForm;